import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  IReportFilterSummaryItem,
  REPORT_EXECUTION_TRANSLATION_PATH,
} from "./reportExecutionUtils";
import {
  filtersSummaryChipSx,
  filtersSummaryChipsSx,
  filtersSummaryItemSx,
  filtersSummaryLabelSx,
  filtersSummarySx,
  filtersSummaryTextSx,
} from "./reportResultStyles";

interface IReportResultMetadataProps {
  items: IReportFilterSummaryItem[];
}

const ReportResultMetadata: React.FC<IReportResultMetadataProps> = ({
  items,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      aria-label={
        t(REPORT_EXECUTION_TRANSLATION_PATH + "metadata.title") as string
      }
      component="section"
      sx={filtersSummarySx}
    >
      {items.map((item) => (
        <Box key={item.label} sx={filtersSummaryItemSx}>
          <Box component="strong" sx={filtersSummaryLabelSx}>
            {item.label}:
          </Box>
          {item.values ? (
            <Box sx={filtersSummaryChipsSx}>
              {item.values.map((value) => (
                <Box component="span" key={value} sx={filtersSummaryChipSx}>
                  {value}
                </Box>
              ))}
            </Box>
          ) : (
            <Box component="span" sx={filtersSummaryTextSx}>
              {item.value}
            </Box>
          )}
        </Box>
      ))}
    </Box>
  );
};

export default ReportResultMetadata;
